import * as types from 'PointOfSale/modules/setDateAndSite/state/types';
import { CLEAR_CURRENT_SESSION } from 'PointOfSale/modules/servingOptions/state/types';

export const initialStates = {
  selectedSiteDetails: {},
  cepType: {},
  date: null,
  servingSites: [],
  fetchingServingSites: false,
  isSetDateAndSitePopupOpen: false,
  isPopupCallFromHeader: false,
};
export default (state = initialStates, { type, payload }) => {
  switch (type) {
    case types.SET_SITE_DATA:
      return {
        ...state,
        ...(payload.siteDate && { date: payload.siteDate }),
        ...(payload.selectedSite && {
          selectedSiteDetails: payload.selectedSite,
        }),
      };
    case types.GET_SERVING_SITES_FETCHING:
      return {
        ...state,
        fetchingServingSites: payload,
      };
    case types.GET_SERVING_SITES_FETCH:
      return {
        ...state,
        servingSites: payload,
      };
    case types.UPDATE_SERVING_SITE_MEAL_COUNT:
      const sites = [...state.servingSites];
      const index = sites.findIndex(s => s.Id === payload.SiteId);

      if (sites[index]) {
        sites[index]['mealCount'] = payload.MealCount;
      }

      return {
        ...state,
        servingSites: sites,
      };
    case types.OPEN_SETUP_POP:
      return {
        ...state,
        isSetDateAndSitePopupOpen: payload.isSetDateAndSitePopupOpen,
        isPopupCallFromHeader: payload.isPopupCallFromHeader,
      };
    case types.SET_CEP_TYPE:
      return {
        ...state,
        cepType: payload,
      };
    case CLEAR_CURRENT_SESSION:
      return {
        ...state,
        cepType: {},
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/setDateAndSite/state/reducer.js